export const STORAGE_KEYS = {
  USER_ID: "user_id",
  IDENTIFY_ID: "identify_id",
  ROLE_ID: "role_id",
  AUTH_KIND: "authority_kind",
  /*
  課題・障害番号: IH-BUG-106
  対応日: 2026/03/24
  担当者: ユリヤ
  修正概要: ヘッダの企業クリニック名が表示されるのにタイムラグがある問題の修正
  */
  COMPANY_NAME: "company_name",
  KENPO_NAME: "kenpo_name",
  /*
  END
  課題・障害番号: IH-BUG-106
  */
};
